import { stringToTitleCase } from '@/utils/functions/stringToTitleCase'
import { LuHeading1, LuHeading2, LuHeading3 } from 'react-icons/lu'
import React, { ReactNode, useState } from 'react'
import clsx from 'clsx'

export type HeadingTypeProps = {
  element: string
  currentElementState: any
  setCurrentElementState: React.Dispatch<any>
}

type TabProps = {
  headingTypes: {
    label: ReactNode
    value: string
  }[]
  currentElementState: any
  setCurrentElementState: React.Dispatch<any>
}

const headingTypes: {
  label: ReactNode
  value: string
}[] = [
  {
    label: <LuHeading1 size={20} />,
    value: 'H1',
  },
  {
    label: <LuHeading2 size={20} />,
    value: 'H2',
  },
  {
    label: <LuHeading3 size={20} />,
    value: 'H3',
  },
  {
    label: 'Normal',
    value: 'p',
  },
]

export const HeadingType = (props: HeadingTypeProps) => {
  const { element, currentElementState, setCurrentElementState } = props

  return (
    <div className="p-3 py-2 rounded-sm">
      <span className="font-semibold">{stringToTitleCase(element)}</span>

      <Tab
        headingTypes={headingTypes}
        currentElementState={currentElementState}
        setCurrentElementState={setCurrentElementState}
      />
    </div>
  )
}

const Tab = (props: TabProps) => {
  const { headingTypes, currentElementState, setCurrentElementState } = props
  const [activeTab, setActiveTab] = useState(currentElementState.heading_type)

  // Fungsi untuk menangani klik tab
  const handleTabClick = (index: any) => {
    setActiveTab(index)
    setCurrentElementState((prevState: any) => ({
      ...prevState,
      heading_type: index,
    }))
  }

  return (
    <div className={'mt-1'}>
      <div style={{ display: 'flex', width: '100%' }}>
        {headingTypes.map((tab, index) => {
          let className = 'border-t border-b border-l w-full flex justify-center items-center text-sm font-medium'

          if (index === 0) {
            className += ' rounded-l-lg' // Tab pertama
          } else if (index === headingTypes.length - 1) {
            className += ' border-r rounded-r-lg'
          }

          return (
            <div
              key={index}
              onClick={() => handleTabClick(tab.value)}
              style={{
                padding: '10px 20px',
                cursor: 'pointer',
                backgroundColor: activeTab === tab.value ? '#a0c2f0' : '#fff',
              }}
              className={clsx(className, { '!bg-blue-50 text-main-blue-alurkerja': activeTab === tab.value })}
            >
              {tab.label}
            </div>
          )
        })}
      </div>
    </div>
  )
}
